import React, { useReducer } from 'react';
import PropTypes from 'prop-types';
import { ProductContext } from 'context/Context';
// import { productData } from 'data/ecommerce/productData';
import { productReducer } from 'reducers/productReducer';
import { getItemFromStore } from 'helpers/utils';

const data = [
 {
  _id: '66a452ed507e9fcaf47624c5',
  code: 'CtuGpU7',
  company: 'ABCD123',
  name: 'Converse Chuck Taylor All Star de perfil bajo',
  type: 'product',
  stock: 'inventory',
  article: 'NYk2w2X',
  image: [
   'https://firebasestorage.googleapis.com/v0/b/inmovilii.appspot.com/o/c-ABCD123%2Farticles%2FNYk2w2X%2F9oxkTdn7KQVwsvgEtg3md?alt=media&token=ae5b5064-0988-44bb-a624-0ee6e859868a'
  ],
  images: [],
  price: 0,
  regularPrice: 15000000,
  quantity: 1,
  tags: ['converse', 'chavos', 'clasicos'],
  categories: ['Textiles', 'Calzado'],
  description:
   'converse chuck taylor all star de perfil bajo para toda ocasión y estilo.  fgdsgsfd hkhfkjdhsfk ljdlfjldsjfl dsjldslkfjlsjf lsjfdskjfslj fsjlfjsljfld ljdlf sldjfldsjflsjf jssljfs fsjjfldsjflsdjflsjf ljdsfjsl fsl dkjfkds',
  shortDescription: 'converse chuck taylor all star de perfil bajo para toda ocasión y estilo.',
  pricingReference: [
   {
    price: 17000000,
    references: ['66941b395aed665068e66ed0', '66941b395aed665068e66ed5', '66941b395aed665068e66ed7', '66941b395aed665068e66ed9'],
    _id: '66a452ed507e9fcaf47624c6'
   },
   {
    price: 17500000,
    references: ['66941b395aed665068e66ed2', '66941b395aed665068e66ed1'],
    _id: '66a452ed507e9fcaf47624c7'
   }
  ],
  financings: [
   {
    name: 'clieintes',
    initialFee: 1,
    maxInitials: 1,
    maxFinancing: 12,
    minInitialPay: 100000,
    minFeeIni: 1200000,
    minFeeFnc: 1200000,
    lateFee: 1,
    rate: 0,
    amortize: 0,
    _id: '66a452ed507e9fcaf47624c8'
   }
  ],
  composition: [],
  specifications: [],
  products: []
 },
 {
  _id: '66a457cb215c9a06d3b6356a',
  code: 'FXLL7Fp',
  company: 'ABCD123',
  name: 'kdsjskfjdsljf',
  type: 'recipe',
  stock: 'available',
  image: [
   'https://firebasestorage.googleapis.com/v0/b/inmovilii.appspot.com/o/c-ABCD123%2Fproducts%2FFXLL7Fp%2Fgma2d6hPv9Y_9lhJfWrrA?alt=media&token=8563446b-bc08-4907-8aec-4b7c805f8a0a'
  ],
  images: [
   'https://firebasestorage.googleapis.com/v0/b/inmovilii.appspot.com/o/c-ABCD123%2Fproducts%2FFXLL7Fp%2FaSifk62cJn_Y9AuUi6J6b?alt=media&token=065e2027-dac9-4d2b-afbe-c59ed71e72b2'
  ],
  price: 30000000,
  regularPrice: 0,
  quantity: 0,
  tags: ['converse', 'clasicos'],
  categories: ['loquesea'],
  description:
   'Encontrada en la página del producto, donde los clientes pueden profundizar para obtener más información antes de tomar una decisión de compra.',
  shortDescription: 'ghfghfghgfhgfhgfhgfhfghgf djhfkshf ksjdjhfksh dshfkdshfk',
  composition: [
   {
    item: 'NYk2w2X',
    quantity: 6,
    references: ['66941b395aed665068e66ed0', '66941b395aed665068e66ed7'],
    _id: '66a457cb215c9a06d3b6356b'
   }
  ],
  specifications: [
   {
    label: 'ghgfhfg',
    property: 'fghgfhgfhgf',
    _id: '66a457cb215c9a06d3b6356c'
   }
  ],
  pricingReference: [],
  products: [],
  financings: []
 }
];

const ProductProvider = ({ children }) => {
 const initData = {
  initProducts: data,
  products: getItemFromStore('products', data),
  cartItems: [], // { ...productData[0], quantity: 3, totalPrice: productData[0].price * 3 }
  promo: null,
  favouriteItems: ['66a452ed507e9fcaf47624c5'],
  cartModal: {
   show: false,
   product: {},
   quantity: 0,
   type: 'add'
  }
 };
 const [productsState, productsDispatch] = useReducer(productReducer, initData);

 const isInShoppingCart = (id, references) =>
  !!productsState.cartItems?.some(cart => cart._id === id && cart.references.every(e => references.some(a => a?._id == e?._id)));

 const isInFavouriteItems = id => productsState.products.find(product => product._id === id)?.isFavorite;
 //  const isInFavouriteItems = id => !!productsState.favouriteItems?.some(product => product === id);

 console.log({ productsState });

 return (
  <ProductContext.Provider value={{ productsState, productsDispatch, isInShoppingCart, isInFavouriteItems }}>
   {children}
  </ProductContext.Provider>
 );
};

ProductProvider.propTypes = {
 children: PropTypes.node.isRequired
};

export default ProductProvider;
